import { getWrapperClassName } from '@/components/design-system/utils'
import React from 'react'

type Props = Readonly<{
  className?: string
  type: 'text' | 'email' | 'password' | 'number' | 'url'
  label: string
  value: string | number
  placeholder: string
  onError: boolean
  onChange: (_: string) => void
}>

export const LTInput = (props: Props) => {
  return (
      <label className={ getWrapperClassName(props.className, 'block') }>
        { props.label !== '' && <span className="text-sm font-bold text-digitalblue">{ props.label }</span> }
        <input
            className={ `block w-full px-3 py-2.5 mt-1 rounded-lg border-2 ${ getBorderInput(props.onError) } focus:ring-0` }
            type={ props.type }
            value={ props.value }
            placeholder={ props.placeholder }
            onChange={ e => props.onChange(e.target.value) }/>
      </label>
  )

  function getBorderInput(aEchoue: boolean): string {
    return aEchoue ? 'border-rose-500' : 'focus:border-digitalblue'
  }
}

LTInput.defaultProps = {
  className: '',
  type: 'text',
  label: '',
  value: '',
  placeholder: '',
  onError: false,
  onChange: () => {
    return
  }
}
